import { Amplitude, Events } from '@iwoca/frontend-tracking-library';
import { TSupportedLocales } from 'types';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';

export const handleLogoTracking = (locale: TSupportedLocales) => {
  Amplitude.track(
    Events.introducerPortal.introducerPortalEventCreator({
      event: AMPLITUDE_EVENTS.internalLinkClicked,
      locale,
      payload: {
        'Page name': document.title,
        URL: window.location.pathname,
        'CTA destination': 'Portal',
        'CTA text': 'Iwoca logo',
        'CTA URL': PATH_NAMES.home(),
      },
    }),
  );
};

export const handleDashboardClickTracking = (locale: TSupportedLocales) => {
  Amplitude.track(
    Events.introducerPortal.introducerPortalEventCreator({
      event: AMPLITUDE_EVENTS.internalLinkClicked,
      locale,
      payload: {
        'Page name': document.title,
        URL: window.location.pathname,
        'CTA destination': 'Portal',
        'CTA text': 'Dashboard',
        'CTA URL': PATH_NAMES.home(),
      },
    }),
  );
};

export const handleProductsClickTracking = (locale: TSupportedLocales) => {
  Amplitude.track(
    Events.introducerPortal.introducerPortalEventCreator({
      event: AMPLITUDE_EVENTS.internalLinkClicked,
      locale,
      payload: {
        'Page name': document.title,
        URL: window.location.pathname,
        'CTA destination': 'Products',
        'CTA text': 'Products',
        'CTA URL': PATH_NAMES.products,
      },
    }),
  );
};

export const handleCalculatorClickTracking = (locale: TSupportedLocales) => {
  Amplitude.track(
    Events.introducerPortal.introducerPortalEventCreator({
      event: AMPLITUDE_EVENTS.internalLinkClicked,
      locale,
      payload: {
        'Page name': document.title,
        URL: window.location.pathname,
        'CTA destination': 'Calculator',
        'CTA text': 'Calculator',
        'CTA URL': PATH_NAMES.calculator(),
      },
    }),
  );
};

export const handleAccountTracking = (locale: TSupportedLocales) => {
  Amplitude.track(
    Events.introducerPortal.introducerPortalEventCreator({
      event: AMPLITUDE_EVENTS.accountMenuClicked,
      locale,
      payload: {
        'Page name': document.title,
        URL: window.location.pathname,
      },
    }),
  );
};

export const handleInviteTracking = (locale: TSupportedLocales) => {
  Amplitude.track(
    Events.introducerPortal.introducerPortalEventCreator({
      event: AMPLITUDE_EVENTS.modalOpened,
      locale,
      payload: {
        'Page name': document.title,
        URL: window.location.pathname,
        'Modal name': 'Invite modal',
      },
    }),
  );
};

export const handleLogoutTracking = (
  locale: TSupportedLocales,
  logoutLink: string,
) => {
  Amplitude.track(
    Events.introducerPortal.introducerPortalEventCreator({
      event: AMPLITUDE_EVENTS.loggedOut,
      locale,
      payload: {
        'Page name': document.title,
        URL: window.location.pathname,
        'CTA destination': 'Logout',
        'CTA text': 'Logout',
        'CTA URL': logoutLink,
      },
    }),
  );
};

export const handleMobileMenuTracking = (locale: TSupportedLocales) => {
  Amplitude.track(
    Events.introducerPortal.introducerPortalEventCreator({
      event: AMPLITUDE_EVENTS.navigationOpened,
      locale,
      payload: {
        'Page name': document.title,
        URL: window.location.pathname,
        'CTA destination': 'Menu',
        'CTA text': 'Menu',
      },
    }),
  );
};
